class Placeholder extends HTMLElement {

  connectedCallback() {
    const type = this.dataset.type || 'image';
    const classTrigger = this.dataset.classTrigger;

    switch (type) {
      case 'image':
        if (classTrigger) {
          this.handleImagePlaceholder(classTrigger);
        } else {
          this.handleInternalImage();
        }
        break;
      // other types can be added here
      default:
        console.warn(`Unsupported placeholder type: ${type}`);
    }
  }

  handleInternalImage() {
    const img = this.querySelector('img');
    if (!img) return;

    const markAsLoaded = () => {
      if (img.naturalWidth > 0) {
        this.classList.add('loaded');
      }
    };

    if (img.complete) {
      markAsLoaded();
    } else {
      img.addEventListener('load', markAsLoaded);
    }
  }

  handleImagePlaceholder(classTrigger) {
    const img = document.querySelector(`.${classTrigger}`);
    if (!img) return;

    const hidePlaceholder = () => {
      if (img.naturalWidth > 0) {
        img.classList.add('loaded');
        this.remove();
      } else {
        console.warn('Image failed to load:', img.src);
      }
    };

    if (img.complete) {
      hidePlaceholder();
    } else {
      img.addEventListener('load', hidePlaceholder);
      img.addEventListener('error', () => { console.error('Image failed:', img.src); });
    }

  }

}

if (!customElements.get('placeholder-box')) {
  customElements.define('placeholder-box', Placeholder);
}